$(document).ready(function (){
  
  // Custom Product-slider.liquid

  $(".grid-products.carousel").on('init afterChange', function(event, slick, direction){
    $(".grid-products.carousel.slick-initialized .slidelazy").each(function(){
      image = $(this);

      viewport_left = $(".grid-products.carousel").offset().left;
      viewport_width = $(".grid-products.carousel").width();

      if(image.offset().left>viewport_left && image.offset().left<=viewport_width){
        if(image.attr('data-bgset')!=""){
          width = Math.ceil(image.width()/50)*50;
          bg = image.attr('data-bgset').replace('_x10','_x'+width);
          image.css('background-image','url('+bg+')');
          image.removeClass('slidelazy');
          image.addClass('slidelazyloaded');
        }

      }
    });
  });
  


  // Product Page set Delivery Time
  if($('body').hasClass('template-product')){
    delivery_time();
  }

  // let link = document.querySelector('body');
  // let target = link.getAttribute('data-rtl');
  // console.log(target);
  // if(target == 'true'){
    
  //   // document.querySelectorAll('.grid-view-item .product-price__price').innerText.replace('SR', 'رس')
  //   console.log(document.querySelectorAll('.grid-view-item .product-price__price').innerText())
  // }

  

        

  
  // data-rtl="true"

  // .grid-view-item .product-price__price
  
  // Mobile Megamenu
//   $('#MobileNav .ad').on('click', function(e) {
//     e.preventDefault();

//     if($(this).hasClass('ad-angle-up-r')){
//       $(this).parents('.mobile-nav').find('.parent.megamenu ul').hide();
//       $(this).parents('.mobile-nav').find('.parent.megamenu .ad').removeClass('ad-angle-up-r');

//     }else{
//       $(this).parents('.mobile-nav').find('.parent.megamenu ul').hide();
//       $(this).parents('.mobile-nav').find('.parent.megamenu .ad').removeClass('ad-angle-up-r');


//       $(this).addClass('ad-angle-up-r');
//       $(this).parents('.parent.megamenu').find('ul').toggle();
//     }


//   });

  
    // Mobile Megamenu
  $('#MobileNav .lvl1.parent.megamenu .mobile_link>.mobile_arrow').on('click', function(e) {
    e.preventDefault();
    
    if($(this).find('.ad').hasClass('ad-angle-up-r'))
    {
      $(this).parents('.mobile-nav').find('.parent.megamenu ul').hide();
      // $(this).parents('.mobile-nav').find('.parent.megamenu .ad').removeClass('ad-angle-up-r');
       $(this).parents('.parent.megamenu').find('.ad').removeClass('ad-angle-up-r');
      console.log('yes');
      $(this).parents('.megamenu').find('ul').removeClass('show');
    }
    else
    {
      console.log('no');
      // $(this).parents('.mobile-nav').find('.parent.megamenu ul').hide();
      // $(this).parents('.mobile-nav').find('.parent.megamenu .ad').removeClass('ad-angle-up-r');
      $(this).parents('.parent.megamenu').find('.ad').removeClass('ad-angle-up-r');

      $(this).parents('.megamenu').find('ul').addClass('show');
      $(this).find('.ad').addClass('ad-angle-up-r');
      $(this).parent().find('ul').toggle();
    }
    
    

  });

});

$(document).mouseup(function (e) {
  var container = $(".search-results");
  if(!container.is(e.target) && 
     container.has(e.target).length === 0) {
    container.hide();
  }
});

 


function delivery_time(){
  var today = new Date();
  var business_days = parseInt($('.shipping-time').attr('data-deliverytime'));
  var deliveryDate = today; //will be incremented by the for loop
  var total_days = business_days; //will be used by the for loop

  for(var days=1; days <= total_days; days++) {
    deliveryDate = new Date(today.getTime() + (days *24*60*60*1000));
    if(deliveryDate.getDay() == 0 || deliveryDate.getDay() == 6) {
      //it's a weekend day so we increase the total_days of 1
      total_days++
    }
  } 

  var rtl = false;
  if($('html').attr('lang')=='ar'){
    rtl = true;
  }

  var weekday = new Array(7);
  weekday[0] = (rtl ? "الأحد" : "Sunday");
  weekday[1] = (rtl ? "الاثنين" : "Monday");
  weekday[2] = (rtl ? "يوم الثلاثاء" : "Tuesday");
  weekday[3] = (rtl ? "الأربعاء" : "Wednesday");
  weekday[4] = (rtl ? "يوم الخميس" : "Thursday");
  weekday[5] = (rtl ? "الجمعة" : "Friday");
  weekday[6] = (rtl ? "السبت" : "Saturday");
  var _day = weekday[deliveryDate.getDay()];

  var month = new Array();
  month[0] = (rtl ? "يناير" : "January");
  month[1] = (rtl ? "شهر فبراير" : "February");
  month[2] = (rtl ? "مارس" : "March ");
  month[3] = (rtl ? "أبريل" : "April");
  month[4] = (rtl ? "مايو" : "May");
  month[5] = (rtl ? "يونيو" : "June");
  month[6] = (rtl ? "يوليو" : "July");
  month[7] = (rtl ? "أغسطس" : "August");
  month[8] = (rtl ? "سبتمبر" : "September");
  month[9] = (rtl ? "اكتوبر" : "October");
  month[10] = (rtl ? "شهر نوفمبر" : "November");
  month[11] = (rtl ? "ديسمبر" : "December");
  var _month = month[deliveryDate.getMonth()];

  $('.delivery-time').html('Delivery in' + '&nbsp;' + '<strong>' + _day + ',' + '&nbsp;' + deliveryDate.getDate() + '&nbsp;' + _month + '</strong>');
}

window.addEventListener("load", (event) => {
  let link = document.querySelector('body');
  let target = link.getAttribute('data-rtl');

  if(target == 'true'){

    const replaceInSelection = (target, replacement, selector) => {
      const t = new RegExp(target, 'g')
      document.querySelectorAll(selector).forEach(
        el => el.textContent = el.textContent.replace(t, replacement)
      ) 
    }
    replaceInSelection('SR', 'رس', '.product-price__price');
    replaceInSelection('SR', 'رس', '.boost-pfs-filter-product-item-regular-price');

    

  }
});

var intervalId = setInterval(function () {
    var allProcessed = true;
    var elements = document.querySelectorAll('.boost-pfs-addtocart-btn-text');

    elements.forEach(function (el) {
      var text = el.textContent.trim().toLowerCase();

      if (text === 'sold out') {
        el.style.setProperty('display', 'block', 'important');
      } else if (text === 'add to cart') {
        el.style.setProperty('display', 'none', 'important');
      } else {
        // If text is not matching expected values, wait and try again
        allProcessed = false;
      }
    });

    if (allProcessed && elements.length > 0) {
      clearInterval(intervalId); // stop checking
    }
  }, 500); // checks every 500ms